export { default as PastFromOffice } from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice'
